module.exports = __webpack_public_path__ + "img/user.777e1321.webp";